import camelize from 'camelize';

import { userConfig, UserData } from './interface';
import { getVuid } from './utils';

const protocol = 'https://';
const userpath = '/me';
const plansPath = '/me/subscription_plans';

const requestHeaders = (jwt?: string) => {
  return {
    Accept: 'application/vnd.vimeo.*+json;version=3.4.7',
    Authorization: `jwt ${jwt}`,
  };
};

const formatUserResponse = (response: any) => {
  let formattedResponse: UserData = camelize(response);
  // camelize plan name as the value is different from plan value fetched from
  // subscription plans API
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  formattedResponse.membership.type = camelize(formattedResponse.membership.type);

  return formattedResponse;
};

export const fetchUserData = async (apiUrl?: string, jwt?: string) => {
  const filterFields = ['name', 'uri', 'membership'];
  const uri = `${protocol}${apiUrl}${userpath}?fields=${filterFields.join(',')}`;

  const response = await fetch(uri, {
    method: 'GET',
    headers: requestHeaders(jwt),
  });

  if (response.ok) {
    const resp = await response.json();
    const formattedResponse: UserData = formatUserResponse(resp);
    return formattedResponse;
  }

  throw response;
};

export const fetchPlansData = async (apiUrl: string | undefined, userConfig: userConfig) => {
  const uri = `${protocol}${apiUrl}${plansPath}?vuid=${getVuid()}`;

  const response = await fetch(uri, {
    method: 'GET',
    headers: requestHeaders(userConfig.jwt),
  });

  if (response.ok) {
    const resp = await response.json();

    return camelize(resp.data);
  }

  throw response;
};
